import React, { createContext, useContext, useRef } from "react";
import { Toast, ToastMessage } from "primereact/toast";
import styles from "./styles.module.css";

type ToastContextType = {
  show: (options: ToastMessage | ToastMessage[]) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const toastRef = useRef<Toast>(null);

  const show = (options: ToastMessage | ToastMessage[]) => {
    toastRef.current?.show(options);
  };

  return (
    <ToastContext.Provider value={{ show }}>
      <Toast ref={toastRef} className={styles.toast} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
